import React from 'react';

function Comunic () {
    return (
        <div className="espacio container-md align-items-center">
            <section class="text-center">
            <div className="espacio">
                <h3>Cumpleaños del mes</h3>
            </div>
            
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                    <img src="https://img.freepik.com/vector-gratis/concepto-letras-feliz-cumpleanos_23-2148499328.jpg?size=626&ext=jpg" class="img-thumbnail" alt="..."></img>
                    </div>
                    <div class="col">
                    <h4 class="card-title">Les deasemos feliz cumpleaños a:</h4>
                    <h6 class="card-text fw-bold">Marco Navarro</h6>
                    <h6 class="card-text fw-bold">Jesús Vázquez</h6>
                    </div>
                </div>
            </div>
            </section>
            <section>
                
            </section>
            <section>
                
            </section>
            <p class="h3 text-center espacio">Comunicados recientes</p>
            <section>
            <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        Tipos de vacunas contra el COVID-19
                    </button>
                    </h2>
                    <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1614832404/ARBAL/SIAR/covid03032021.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                        Congreso de Ciberseguridad BAL
                    </button>
                    </h2>
                    <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1611085760/ARBAL/SIAR/congresoBAL.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                        Sanitización de oficinas
                    </button>
                    </h2>
                    <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1614832404/ARBAL/SIAR/sanitizaci%C3%B3nArbal.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
            </div>
            </section>

            <section class="text-center espacio">
                <div class="espacio">
                <h3>Nuestros valores</h3>
                </div>
                <div class="card-body">
                    <div class="row align-items-center">
                        <div class="col">
                        <h4 class="card-title">Misión</h4>
                        <h6 class="card-text fw-bold">Fundada en 1999</h6>
                        Conoce más
                        </div>
                        <div class="col">
                        <h4 class="card-title">Visión</h4>
                        <h6 class="card-text fw-bold">Fundada en 1999</h6>
                        Conoce más
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Comunic